import { Menu, Typography } from "@material-ui/core";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { StyledMenuItem, StyledListItemIcon } from 'components/WPReactTable/components/HeaderColumn';

import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
const MenuCreateNew = ({
  setOpenCreateTaskGroup,
  setOpenMenuCreate,
  anchorEl,
  setAnchorEl,
  setOpenCreate,
}) => {
  const opens = Boolean(anchorEl);
  const { t } = useTranslation();
  const id = opens ? "simple-popover" : undefined;
  return (
    <Menu
      id="menu-create"
      anchorEl={anchorEl}
      open={Boolean(opens)}
      onClose={() => setAnchorEl(null)}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: "bottom", horizontal: "start" }}
      transformOrigin={{ vertical: "top", horizontal: "start" }}
    >
      <StyledMenuItem
        style={{ marginBottom: 5 }}
        onClick={() => {
          setOpenCreate(true);
          setOpenMenuCreate(false);
        }}
      >
        <StyledListItemIcon>
          <AddCircleOutlineIcon />
        </StyledListItemIcon>
        <Typography textalign="center">{t("LABEL_CREATE_WORK")}</Typography>
      </StyledMenuItem>

      <StyledMenuItem
        style={{ marginTop: 5 }}
        onClick={() => {
          setOpenCreateTaskGroup(true);
          setOpenMenuCreate(false);
        }}
      >
        <StyledListItemIcon>
          <AddCircleOutlineIcon />
        </StyledListItemIcon>
        <Typography textalign="center">{t("LABEL_CREATE_WORKING_GROUP")}</Typography>
      </StyledMenuItem>
    </Menu>
  );
};

export default MenuCreateNew;
